import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import { history } from 'helpers';
import { getUserRole } from 'helpers/utis';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

export function ListItem({ icon, title, subOptions, link, isMenuOpen }) {
  const isActiveItem = useMemo(() => {
    const pathName = history.location.pathname;
    return pathName.includes(link);
  }, [history.location.pathname, link]);

  const isSubActiveItem = useCallback(
    (subLink) => {
      const pathName = history.location.pathname;
      return pathName.includes(subLink);
    },
    [history.location.pathname]
  );

  const containsSubOptions = useMemo(
    () => subOptions?.length > 0,
    [subOptions]
  );

  const [isOpen, setOpen] = useState(false);

  const handleClick = (routeLink, type) => {
    if (containsSubOptions && type === 'main') return setOpen(!isOpen);
    return history.push(routeLink);
  };

  const renderButton = () => {
    return (
      <button
        // className={`item ${isActiveItem && 'itemHighlight'} ${
        //   containsSubOptions ? 'sub-options' : ''
        // }  ${isOpen ? 'open-options' : ''}`}
        className={`item ${isActiveItem ? 'active-item' : ''} ${
          containsSubOptions ? 'sub-options' : ''
        } ${isOpen ? 'open-options' : ''}`}
        type="button"
        onClick={() => handleClick(link, 'main')}
      >
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            className="sidebar-item-icon"
            color="#fff"
          />
        )}
        {isMenuOpen && (
          <>
            <p
              className={`item-label ${containsSubOptions ? 'text-white' : ''}`}
            >
              {title}
            </p>
            {containsSubOptions && (
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`dropdown-icon ${isOpen ? 'rotate' : ''}`}
              />
            )}
          </>
        )}
      </button>
    );
  };

  const renderSubButton = (label, subLink) => {
    return (
      <button
        // className={`sub-option-item p-0 ${
        //   isSubActiveItem(subLink) ? 'sub-item-active' : ''
        // }`}
        className={`sub-option-item ${
          isSubActiveItem(subLink) ? 'sub-item-active' : ''
        }`}
        type="button"
        key={subLink}
        onClick={() => handleClick(subLink, 'sub')}
      >
        <span
          className={`legend ${
            isSubActiveItem(subLink) ? 'legend-active' : ''
          }`}
        />
        {isMenuOpen ? label : ''}
      </button>
    );
  };

  return (
    <li className={`item ${isActiveItem ? 'active-item' : ''}`}>
      {!isMenuOpen ? (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id={`tooltip-${title}`}>{title}</Tooltip>}
          delay={{ show: 100, hide: 50 }}
        >
          {renderButton()}
        </OverlayTrigger>
      ) : (
        renderButton()
      )}

      {containsSubOptions && (
        <div
          className={`sub-options-container d-flex flex-column ${
            isOpen ? 'show-options' : 'hide-options'
          }`}
        >
          {subOptions
            .filter((sub) => getUserRole(sub.role))
            .map(({ label, subLink }) =>
              !isMenuOpen ? (
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id={`tooltip-${label}`}>{label}</Tooltip>}
                  delay={{ show: 100, hide: 50 }}
                >
                  {renderSubButton(label, subLink)}
                </OverlayTrigger>
              ) : (
                renderSubButton(label, subLink)
              )
            )}
        </div>
      )}
    </li>
  );
}

ListItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  link: PropTypes.string,
  isMenuOpen: PropTypes.bool,
  subOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      subLink: PropTypes.string
    })
  )
};

ListItem.defaultProps = {
  icon: '',
  title: '',
  link: '',
  isMenuOpen: true,
  subOptions: []
};
